export const roles = [{
    name: 'Moderator',
    value: 'moderator'
},{
    name: 'Editor',
    value: 'editor'
},{
    name: 'Viewer',
    value: 'viewer'
}]
export const profileStatuses = [{
    name: 'Active',
    value: 'active'
},{
    name: 'Revoked',
    value: 'revoked'
}]